<script setup lang="ts">
// Vue
import { computed, watch, onMounted } from "vue";

// Data Providers
import { useDefaultModels } from "@/dataProviders/DefaultModels";

// GraphQL
import { useGetModelsLazyQuery, Country_Enum } from "@/graphql";

// Components
import GraphQLError from "@/features/GraphQLError";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  country: Country_Enum | null;
}>();

// ///////////////////
// Data Providers
// ///////////////////

const defaultModels = useDefaultModels();

// ///////////////////
// Variables
// ///////////////////

const queryVariables = computed(() => ({
  country: props.country as Country_Enum,
}));

// ///////////////////
// Query
// ///////////////////

const { result, loading, error, refetch, load } = useGetModelsLazyQuery(
  props.country ? queryVariables.value : { country: Country_Enum.DENMARK },
  {
    fetchPolicy: "no-cache",
  }
);

// ///////////////////
// Lifecycle
// ///////////////////

onMounted(() => {
  load();
});

// ///////////////////
// Watchers
// ///////////////////

watch(
  () => props.country,
  (newValue) => {
    if (newValue) {
      refetch(queryVariables.value);
    }
  }
);

watch(
  result,
  (newValue) => {
    if (newValue) {
      defaultModels.mapData(newValue);
    }
  },
  { deep: true }
);

watch(loading, (newLoading) => {
  defaultModels.setLoading(newLoading);
});
</script>

<template>
  <GraphQLError
    :error="error"
    name="DefaultModels" />
</template>
